import Controller, { OnMount, OnClick, OnChange } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import { FieldAPI, FormAPI, ImageAPI, TextAPI, ButtonAPI, InputAPI } from '@philips-internal/oswald-ui-components';
import { CONFIRMATION_FIELD_VALID, confirmationFieldValidator, optionsValidator } from '../../utils/user-util';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

@Controller({ fragment: 'account-create-new-password', component: 'root-layout' })
export default class AccountCreationNewPasswordController extends BaseController {

  @Inject('confirm-password-validation-text')
  confirmPasswordValidationText: TextAPI;

  @Inject('password-form')
  passwordForm: FormAPI;

  @Inject('logo-image')
  ImageHeader: ImageAPI;

  @Inject('password-field')
  passwordField: FieldAPI;

  @Inject('confirm-password-field')
  passwordConfirmationField: FieldAPI;

  @Inject('password-admit-button')
  buttonCreate: ButtonAPI;

  @Inject('confirm-password-input')
  inputConfirmPassword: InputAPI;

  password: string;
  confirmPassword: string;

  @OnMount({ target: 'root-layout' })
  chackActivedUser(): void {
    const hash = this.historyService.getCurrentRouteParams().token;
    HttpService.get(APPLICATION_ENDPOINTS.CHECK_ACTIVED_USER, { hash }).then(resp => {
      const { activatedUser } = resp.body as { activatedUser: number };
      if (activatedUser == 0) {
        this.historyService.push(APPLICATION_ROUTES.ACTIVE_USE_FAIL);
      }
    });
  }

  @OnMount({ target: ['password-form'] })
  onFormMount(): void {
    this.passwordConfirmationField.addLocalValidator(CONFIRMATION_FIELD_VALID, () => {
      return confirmationFieldValidator(this.password, this.confirmPassword, 'pwd');
    }, optionsValidator());
  }

  @OnClick({ target: ['password-admit-button'] })
  onChangePasswordAdmitButton(): void {
    const body = this.passwordForm.getRecord();
    const routeParams = this.historyService.getCurrentRouteParams() as Record<string,string>;
    body.hashUser = routeParams.token;

    HttpService.post(APPLICATION_ENDPOINTS.CREATE_NEW_PASSWORD, {}, { body }).then(() => {
      this.historyService.push(APPLICATION_ROUTES.ACTIVE_USE_SUCCESS)
    }).catch(() => this.historyService.push(APPLICATION_ROUTES.ACTIVE_USE_FAIL));
  }

  @OnChange({ target: 'password-input' })
  async onPasswordChange(event: ChangeEvent<string>): Promise<void> {
    this.password = event.value as string;
    if (this.confirmPassword) {
      if(await this.passwordConfirmationField.validate()){
        this.buttonCreate.setEnabled(true)
      } else {
        this.buttonCreate.setEnabled(false);
      }
    }
  }

  @OnChange({ target: 'confirm-password-input' })
  async onConfirmPasswordChange(event: ChangeEvent<string>): Promise<void> {
    this.confirmPassword = event.value as string;
    if(await this.passwordConfirmationField.validate()){
      this.buttonCreate.setEnabled(true)
    } else {
      this.buttonCreate.setEnabled(false);
    }
  }

}
